import { cn } from '@/lib/utils'
import { useTranslation } from '@/lib/i18n'

/**
 * Spec 02 · The mark.
 *
 * Aerosoldier, display only — never below 40px in the footer, never
 * for sentences, never for UI. The wordmark is lowercase "sick stuff".
 * Line-height 0.9 with 0.1em of bottom padding so the descenders
 * aren't clipped by the box.
 *
 * The graffiti class rather than the display one: the mark is the same
 * two English words on the Russian storefront, so it keeps the hand
 * there instead of following the locale's display face.
 *
 * Pass `size` for a fixed pixel size, or leave it off and set the size
 * from `className` when it needs to respond to the breakpoint.
 */
function Wordmark({ size, className }: { size?: number; className?: string }) {
  const { t } = useTranslation()

  return (
    <span
      className={cn('sss-graffiti block', className)}
      style={size ? { fontSize: size } : undefined}
      translate="no"
    >
      {t('layout.brand')}
    </span>
  )
}

export { Wordmark }
